import { useState, useEffect, useContext } from "react"
import { DrowerBottom, BtnLoader } from "../../components"
import { toast } from "react-toastify"
import { HandelApi } from "../../api"
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ContextNav } from "../../context/ContextNav";
import { CSvgList } from "../../components/CSvg";
import { RecordMethods } from '../../methods'
import QrReader from 'react-qr-reader';

export const Record = () => {
    const [displayBtn, setDisplayBtn] = useState<boolean>(false)
    const [visible, setVisible] = useState<boolean>(false)
    const [displayScanner, setDisplayScanner] = useState<boolean>(false)
    const [typeRecord, setTypeRecord] = useState<any>(null)
    const [changeMethod, setChangeMethod] = useState<any>('scan')
    const [position, setPosition] = useState<any>(null)
    const navigate = useNavigate();
    const CtxNav = useContext(ContextNav)

    const handelStartSubmit = () => {
        if (changeMethod == 'scan') {
            setDisplayScanner(true)
        }
        else {
            handelSubmit(null, 'link')
        }
        setVisible(false)
    }

    const handelOpenQuestionBox = (type: string) => {
        setTypeRecord(type)
        setVisible(true)
    }

    const errorCallback = (error: any) => {
        toast('دسترسی به موقعیت توسط دستگاه شما امکان پذیر نیست', { type: "error" })
    }

    const showPosition = (pos: any) => {
        setPosition([pos.coords.latitude, pos.coords.longitude])
    }

    const handelLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(showPosition, errorCallback);
        } else {
            toast('مرورگر شما موقعیت مکانی را پشتیبانی نمیکند', { type: "error" })
        }
    }

    const handelSubmit = async (scanData: any, typeScan: any) => {
        RecordMethods(position, typeRecord, typeScan, scanData, setDisplayBtn, setVisible, setDisplayScanner, displayBtn)
    }

    useEffect(() => {
        document.title = "ثبت تردد | دایان"
        handelLocation()
    }, [])


    return (
        <>
            <div className='w-full h-screen flex flex-col justify-between items-center bg-[#f9f9f9]'>
                <div className={`w-full h-[70px] flex items-center justify-between px-4 bg-[#f9f9f9]`}>
                    <CSvgList onClick={() => { CtxNav.setdisplayMenu(true) }} className='w-[30px] cursor-pointer' />
                    <img src='/assetes/logo/logo.png' alt='logo' className='h-[60px]' />
                    <span></span>
                </div>
                {displayScanner && (
                    <>
                        <div className={`md:w-[80%] w-[95%] flex flex-col justify-center items-center`}>
                            <QrReader
                                facingMode={'environment'}
                                delay={1000}
                                onError={() => { }}
                                onScan={(e: any) => handelSubmit(e, 'scan')}
                                // chooseDeviceId={()=>selected}
                                style={{ width: "250px", height: "250px" }}
                            />
                            <div onClick={() => { setDisplayScanner(false) }} className='w-[250px] h-[55px] mt-[20px] rounded-full bg-white shadow  flex items-center justify-center px-1 cursor-pointer'>
                                <span className='text-sm'>بستن دوربین</span>
                            </div>
                        </div>
                    </>
                )}
                {!displayScanner && (
                    <div className='w-full flex flex-col items-center justify-center'>
                        <span>لطفا نوع تردد خود را انتخاب کنید</span>
                        <div onClick={() => handelOpenQuestionBox('entrance')} className='w-[250px] h-[55px] rounded-full bg-white shadow my-[20px] flex items-center justify-center px-1 cursor-pointer'>
                            <h3 className='text-[18px] text-dayan-orange-50 font-bold'>ثبت ورود</h3>
                        </div>
                        <div onClick={() => handelOpenQuestionBox('exit')} className='w-[250px] h-[55px] rounded-full bg-white shadow  flex items-center justify-center px-1 cursor-pointer'>
                            <h3 className='text-[18px] text-dayan-orange-50 font-bold'>ثبت خروج</h3>
                        </div>
                        {changeMethod == 'scan' ?
                            <span onClick={() => { setChangeMethod('link') }} className='mt-7 text-gray-500 cursor-pointer'>ثبت تردد مستقیم</span>
                            :
                            <span onClick={() => { setChangeMethod('scan') }} className='mt-7 text-gray-500 cursor-pointer'>ثبت تردد با اسکن</span>
                        }
                    </div>
                )}
                <span></span>
            </div>




            <DrowerBottom visible={visible} setVisible={setVisible} >
                <div className='w-full flex flex-col justify-center items-center pt-[20px]'>
                    {typeRecord == 'entrance' ?
                        <span>آیا از ثبت ورود مطمئن هستید ؟</span>
                        :
                        <span>آیا از ثبت خروج مطمئن هستید؟</span>
                    }
                    <div className="w-full flex  items-center justify-center mt-[40px]">
                        {displayBtn ?
                            <div className="w-[120px] h-[40px] mx-2 bg-dayan-orange-50 text-white flex items-center justify-center rounded-md relative"><BtnLoader /></div>
                            :
                            <div onClick={handelStartSubmit} className="w-[120px] h-[40px] mx-2 bg-dayan-orange-50 text-white flex items-center justify-center rounded-md cursor-pointer">ثبت</div>
                        }
                        {/* {displayBtn ?
                            <div className="w-[200px] h-[40px] my-2 bg-dayan-orange-50 text-white flex items-center justify-center rounded-md relative"><BtnLoader /></div>
                            :
                            <div onClick={() => handelSubmit(null, 'link')} className="w-[200px] h-[40px] my-2 bg-dayan-orange-50 text-white flex items-center justify-center rounded-md cursor-pointer">لینک اختصاصی</div>
                        } */}
                        <div onClick={() => { setVisible(false) }} className="w-[120px] h-[40px] mx-2 border border-dayan-orange-50 text-dayan-orange-50 flex items-center justify-center rounded-md cursor-pointer">انصراف</div>
                    </div>
                </div>
            </DrowerBottom>

        </>
    );
}